import { render } from "./FootMap.vue?vue&type=template&id=6157396d"
import script from "./FootMap.vue?vue&type=script&lang=js"
export * from "./FootMap.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__